// eslint-disable-next-line no-shadow
export enum PageStateModuleId {
  BusinessProfile = 1,
  FinancialProfile = 2,
  CustomerPortfolio = 3,
}
